import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const DfeLogo = ({ size = 40 }) => (
  <img
    src="/api/files/dfe-website/uploads/dfe-logo.png"
    alt="DFE 娛樂夢工廠 Dream Factory Entertainment"
    style={{ height: Math.round(size * 0.72), width: "auto", display: "block" }}
  />
);

const LINKS = [
  { to: "/about", zh: "关于", en: "ABOUT" },
  { to: "/works", zh: "作品", en: "WORKS" },
  { to: "/calendar", zh: "演出日历", en: "CALENDAR" },
  { to: "/services", zh: "服务", en: "SERVICES" },
  { to: "/team", zh: "团队", en: "TEAM" },
  { to: "/contact", zh: "联络", en: "CONTACT" },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const { lang, setLang } = useLang();
  const toggleLang = () => setLang(lang === "zh" ? "en" : "zh");

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-[100] bg-[#050505]/95 border-b border-white/10 backdrop-blur-sm">
        <div className="max-w-[1800px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center">
            <DfeLogo size={48} />
          </Link>
          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.en.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex flex-col items-start leading-none transition-colors ${isActive ? "text-[#ffde00]" : "text-[#f5f5f5] hover:text-[#ffde00]"}`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="font-zh text-sm">{lang === "zh" ? l.zh : l.en}</span>
                    <span className={`font-mono2 text-[9px] tracking-[0.3em] mt-0.5 ${isActive ? "text-[#ffde00]" : "text-[#52525b]"}`}>
                      {lang === "zh" ? l.en : l.zh}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
            <button
              onClick={toggleLang}
              data-testid="lang-toggle"
              className="font-mono2 text-[11px] border border-white/20 px-3 py-1.5 text-[#f5f5f5] hover:border-[#ffde00] hover:text-[#ffde00] transition-colors bg-transparent cursor-pointer tracking-[0.15em]"
            >
              {lang === "zh" ? "EN" : "中文"}
            </button>
            <Link to="/contact" data-testid="nav-cta" className="btn-yellow !py-2.5 !px-5">
              {lang === "zh" ? "商业合作" : "ENQUIRE"}
              <ArrowUpRight size={14} />
            </Link>
          </nav>
          <div className="flex lg:hidden items-center gap-3">
            <button
              onClick={toggleLang}
              data-testid="lang-toggle-mobile"
              className="font-mono2 text-[11px] border border-white/20 px-2.5 py-1.5 text-[#f5f5f5] bg-transparent cursor-pointer tracking-[0.15em]"
            >
              {lang === "zh" ? "EN" : "中文"}
            </button>
            <button
              className="text-[#f5f5f5] bg-transparent border-0 cursor-pointer p-1"
              data-testid="nav-mobile-toggle"
              aria-label="菜单"
              onClick={() => setOpen(!open)}
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>
      {open && (
        <div className="fixed inset-0 z-[90] bg-[#050505] pt-24 px-6 lg:hidden overflow-y-auto">
          <nav className="flex flex-col gap-2 pb-10">
            {LINKS.map((l, i) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.en.toLowerCase()}`}
                className="text-left bg-transparent border-0 border-b border-white/10 py-4 flex items-baseline gap-4"
              >
                <span className="font-mono2 text-xs text-[#ffde00]">0{i + 1}</span>
                <span className="font-display text-3xl text-[#f5f5f5] uppercase">{lang === "zh" ? l.zh : l.en}</span>
                <span className="font-mono2 text-[10px] text-[#a1a1aa] tracking-[0.3em]">{lang === "zh" ? l.en : l.zh}</span>
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
